export const UPDATE_STUDENT_MAP_GRADE_LEVEL = `
  mutation updateStudentGrade($input: UpdateStudentGradeInput!) {
    updateStudentGrade(input: $input) {
      platformStudentId
      gradeLevel
    }
  }
`;
